<template>
  <!-- {{ resource.imageUri }} -->
  <div v-show="searchDisplayType === 'grid' || display === 'queue'" ref="grid"
    :title="display === 'queue' ? 'Unselect Item' : 'Select Item'" class="marketing-item-container c"
    @click="handleItemClick" @mouseover="handleItemOver" @mouseout="handleItemOut">
    <div class="save-holder">
      <SavedMarker v-if="type !== 'upload' && display !== 'queue'" ref="savedMarker" class="bookmark-offset"
        title="Save Item" @mouseup="handleBookmark" />
      <UnselectMarker v-if="type !== 'upload' && display === 'queue'" class="unselect-marker" />
    </div>
    <div class="image-holder">
      <img
        :src="(type === 'upload') ? getFileType(this.$props.resource.imageUri, this.$props.resource.file) : resource.imageUri"
        class="image" alt="Download" />
    </div>
    <div class="label">
      {{ resource.name }}
    </div>
    <div v-if="display === 'full' && resource.downloadUri != null" class="download" title="Download Item"
      @mouseup="handleItemDownload($event, resource.downloadUri, resource.name)">
      <img :src="require('@/assets/svg/SVG/download.svg')" alt="Download">
    </div>
  </div>

  <div v-show="searchDisplayType === 'list' && display === 'full'" ref="list" title="Select Item"
    class="marketing-item-list-container c" @click="handleItemClick" @mouseup="handleItemUp" @mouseover="handleItemOver"
    @mouseout="handleItemOut">
    <div class="left-side">
      <SelectionMarker v-show="inMultiSelectionMode && display === 'full'" ref="selectionMarkerList"
        class="selectionMarkerList" title="Select Item" />
      <div class="image-list">
        <img v-if="type === 'upload'" :src="getImageType()" alt="image" class="list-image">
        <img v-else :src="resource.imageUri" alt="image" class="list-image">
      </div>
      <div class="label">
        {{ resource.name }}
      </div>
    </div>
    <div class="right-side">
      <div v-if="display === 'full' && resource.downloadUri != null" class="download download-list"
        title="Download Item" @mouseup="handleItemDownload($event, resource.downloadUri, resource.name)">
        <img :src="require('@/assets/svg/SVG/download.svg')" alt="Download">
      </div>
      <SavedMarker v-if="this.$route.name.toLowerCase() === 'library'" ref="savedMarkerList" title="Save Item"
        @mouseup="handleBookmark" />
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia/dist/pinia';
import { gsap } from 'gsap';
import SavedMarker from '@/components/libraries/search/marketingItem/SavedMarker';
import SelectionMarker from '@/components/libraries/search/marketingItem/SelectionMarker';
import UnselectMarker from '@/components/libraries/search/marketingItem/UnselectMarker';
import Axios from 'axios';
import { useRMTStore } from '@/store/RMTStore';

export default {
  components: {
    SelectionMarker,
    SavedMarker,
    UnselectMarker
  },
  props: [
    'num',
    'resource',
    'display',
    'type'
  ],
  computed: {
    ...mapStores(useRMTStore),
    searchDisplayType () {
      console.log(this.RMTStore.getSearchDisplayType);
      return this.RMTStore.getSearchDisplayType;
    },
    inMultiSelectionMode () {
      return this.RMTStore.getInMultiSelectionMode;
    },
    selectedResources () {
      return this.RMTStore.selectedResources;
    },
    selected () {
      return this.resource.isSelected;
    },
    favorite () {
      return this.resource.isFavorite;
    },
  },
  watch: {
    selected () {
      this.toggleHighlight();
    },
    favorite () {
      this.toggleSavedHighlight();
    },
    searchDisplayType () {
      this.toggleHighlight();
    }
  },
  mounted () {
    this.toggleHighlight();
    this.toggleSavedHighlight();
    // sets the default selected image in queue. When in upload mode 
    // for uploads, there is no ID, so we're going to use the index from the v-for loop to create one
    if (this.$props.resource.id === undefined) { this.$props.resource.id = this.$props.num; }
  },
  methods: {
    saveFavorites () {
      this.RMTStore.saveFavorites();
    },
    // will need more cases with other files to display properly
    getImageType () {
      let item;
      if (this.$props.resource.type == 'application/pdf') {
        item = 'https://nelsonirrigation.com/images/thumbnails/pdf.png';
      } else {
        item = this.$props.resource.imageUri;
      }
      return item;
    },
    getFileType (uri, fileName) {
      let type = fileName.substr(fileName.lastIndexOf('.') + 1);
      type = type.toLowerCase();
      let file;
      switch (type) {
         case 'pdf':
            file = 'https://nelsonirrigation.com/images/thumbnails/pdf.png';
            break;
         case 'psd':
            file = 'https://nelsonirrigation.com/images/thumbnails/psd.png';
            break;
         case 'dwg': 
            file = 'https://nelsonirrigation.com/images/thumbnails/dwg.png';
            break;
         default:
            file = uri;
            break;
      }
      return file;
    },

    handleItemOver () {
      if (!this.$props.resource.isSelected) {
        let el = (this.searchDisplayType === 'grid') ? this.$refs.grid : this.$refs.list;
        gsap.to(el, {
          borderColor: '#c2c2c2',
          backgroundColor: '#fafafa',
          duration: .2
        });
      }
    },
    handleItemOut () {
      if (!this.$props.resource.isSelected) {
        let el = (this.searchDisplayType === 'grid') ? this.$refs.grid : this.$refs.list;
        gsap.to(el, {
          borderColor: '#ffffff',
          backgroundColor: '#ffffff',
          duration: .2
        });
      }
    },
    handleItemClick (e) {
      console.log(e);
      if(this.$props.display === 'queue') {

        e.stopImmediatePropagation();
        this.$props.resource.isSelected = false;
        this.RMTStore.updateAssociations();

        if (this.RMTStore.searchType === 1) {
          this.RMTStore.removeResourceFromCollection(this.$props.resource);
        }

        return;
        
      }

      if (!this.RMTStore.inMultiSelectionMode) {

        if (e.shiftKey) {
          this.RMTStore.inMultiSelectionMode = true;
        }

        if (!e.shiftKey) {
          this.RMTStore.inMultiSelectionMode = false;
        }

      } else {


        if (this.$props.resource.isSelected && !e.shiftKey && !this.RMTStore.inCreateCollectionMode) {
          this.RMTStore.inMultiSelectionMode = false;
          this.RMTStore.clearSelectedUploads();
          this.RMTStore.clearSelectedResources();
          this.$props.resource.isSelected = false;
        }

      }

      if (e !== undefined) { e.preventDefault(); }

      if (this.RMTStore.inMultiSelectionMode) {
        this.$props.resource.isSelected = !this.$props.resource.isSelected;
      } else {
          if (this.$props.resource.isSelected) {
            this.RMTStore.clearSelectedResources();
            this.RMTStore.clearSelectedUploads();
          } else {
            this.RMTStore.clearSelectedResources();
            this.RMTStore.clearSelectedUploads();
            this.RMTStore.setSelectedItemNum(this.$props.num);
            this.$props.resource.isSelected = true;
          }
      }

      let resources = (!this.RMTStore.inUploadMode) ? this.RMTStore.selectedResources : this.RMTStore.selectedUploads;

      if (!this.RMTStore.inUploadMode) {
        this.RMTStore.setPanelIsHidden(resources.length === 0);
      }
      if (this.RMTStore.inMultiSelectionMode) {
         this.RMTStore.setSelectedItemNum(this.$props.num);
      }
      this.RMTStore.updateAssociations();
      console.log(this.RMTStore.selectedResources);

    },
    handleItemDownload (e, url, label) {
      e.stopImmediatePropagation();
      var contentType = 'application/pdf';
      // check what we are trying to download so we can set the type
      if (url.indexOf('images') > -1) {
        // determine what type of image
        contentType = 'image/png';
      }
      Axios.get(url, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: contentType });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = label;
          link.click();
          URL.revokeObjectURL(link.href);
        }).catch(console.error);
    },
    handleBookmark (e) {
      e.stopImmediatePropagation();
      e.preventDefault();
      this.$props.resource.isFavorite = !this.$props.resource.isFavorite;
      this.saveFavorites();
    },
    toggleHighlight () {
      if (this.$props.display === 'queue') { return; }
      let el = (this.searchDisplayType === 'grid') ? this.$refs.grid : this.$refs.list;
      if (this.$props.resource.isSelected) {
        gsap.to(el, {
          borderColor: 'black',
          backgroundColor: '#fafafa',
          duration: .2
        });
        this.$refs.selectionMarkerList.selected();
      } else {
        gsap.to(el, {
          borderColor: 'white',
          backgroundColor: '#ffffff',
          duration: .2
        });
        this.$refs.selectionMarkerList.unselected();
      }
    },
    toggleSavedHighlight () {
      if (this.type === 'upload') { return; }
      // todo: how do you move a component from one location in the component tree to another location?
      if (this.$props.resource.isFavorite) {
        if (this.$refs.savedMarker != null) {
          this.$refs.savedMarker.highlight();
        }
        if (this.$refs.savedMarkerList != null) {
          this.$refs.savedMarkerList.highlight();
        }
      } else {
        if (this.$refs.savedMarker != null) {
          this.$refs.savedMarker.unhighlight();
        }
        if (this.$refs.savedMarkerList != null) {
          this.$refs.savedMarkerList.unhighlight();
        }
      }
    }
  }
};
</script>

<style scoped>
.marketing-item-container {
  /*
  width: calc(25% - 4px);
  */
  padding-bottom: 5px;
  width: 100%;
/*  height: 25vh;*/
  max-height: 250px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;
  cursor: pointer;
  border: 1px solid white;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.image-holder {
  width: 50%;
  max-width: 100px;
}

.image {
  width: 100%;
  height: 100%;
  object-fit: contain;
/*  height: 50%;
  width: 50%;*/
/*  scale: 2;*/
  pointer-events: none;
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  align-items: center;
  box-shadow: 2px 4px 43px -32px #A6B5A6;
}

.label {
  pointer-events: none;
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  font-size: .78em;
  font-weight: bold;
  max-height: 78px;
  line-height: 1.2em;
  line-clamp: 3;
}
.label-list {
  white-space: nowrap;
}
.download {
  text-align: center;
  width: 17px;
  height: 17px;
  align-self: center;
  margin-top: auto;
}
.download-list {
  margin-right: 15px;
}
.download img {
  width: 100%;
  height: 100%;
}
.marketing-item-list-container {
  user-select: none;
  width: 100%;
  padding: 2px;
  margin-bottom: 5px;
  margin-left: 2px;
  margin-right: 2px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  border: 1px solid #f5f5f5;
}
.left-side {
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.right-side {
  display: flex;
  align-items: center;
  justify-content: center;
}
.selectionMarkerList {
  margin-left: 15px;
  margin-right: 15px;
}
.list-image {
  object-fit: contain;
  height: 55px;
  width: 100px;
  min-width: 100px;
}
.image-list {
  height: 55px;
}

.save-holder {
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
</style>